import { EXISTING_HIGHLIGHT_DATAPOINT, NEW_HIGHLIGHT_DATAPOINT } from '../utils/constants';
import shouldDisableOption from '../utils/shouldDisableOption';
import { observer } from 'mobx-react-lite';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { logUsage } from 'owa-analytics';
import loc from 'owa-localize';
import { MailIcons } from 'owa-mail-icons';
import { lazyReplyWithText, ReplyWithTextFeatures } from 'owa-mail-message-actions';
import { ClientItem } from 'owa-mail-store';
import isReplyToAll from 'owa-readonly-recipient-well/lib/utils/isReplyToAll';
import Message from 'owa-service/lib/contract/Message';
import React from 'react';
import {
    UserMarkup_replyAllWithQuote,
    UserMarkup_replyWithQuote,
} from './UserMarkupPopup.locstring.json';

const styles = require('./UserMarkupPopup.scss');

export interface QuoteOptionProps {
    selectedText: string;
    item: ClientItem;
    isForExistingUserHighlight: boolean;
    destroyPopupDivCallback: () => void;
}

const QuoteOption = observer(function QuoteOption(props: QuoteOptionProps) {
    const { selectedText, item, isForExistingUserHighlight, destroyPopupDivCallback } = props;

    const onReplyWithQuote = React.useCallback(() => {
        lazyReplyWithText
            .importAndExecute(
                item.ItemId.Id,
                item.ConversationId.Id,
                selectedText,
                ReplyWithTextFeatures.UserMarkup
            )
            .then(() => {
                // Log ReplyWithQuote datapoint
                logUsage('UserMarkup_ReplyWithQuote', [
                    isForExistingUserHighlight
                        ? EXISTING_HIGHLIGHT_DATAPOINT
                        : NEW_HIGHLIGHT_DATAPOINT,
                ]);
            });
        destroyPopupDivCallback();
    }, [selectedText, item, isForExistingUserHighlight, destroyPopupDivCallback]);

    const isReplyAll = isReplyToAll(item as Message);
    const isDisabled = shouldDisableOption(item);

    return (
        <TooltipHost
            content={
                isReplyAll ? loc(UserMarkup_replyAllWithQuote) : loc(UserMarkup_replyWithQuote)
            }>
            <IconButton
                className={styles.UserMarkupPopupButton}
                iconProps={{ iconName: MailIcons.Comment }}
                onClick={onReplyWithQuote}
                disabled={isDisabled}
            />
        </TooltipHost>
    );
});

export default QuoteOption;
